import React from 'react';
import { Typography, Box } from '@mui/material';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Bem-vindo à Plataforma Bnei Noach
      </Typography>
      <Box>
        <Typography variant="body1">
          Página inicial em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Home; 